import { useState, useEffect } from 'react';
import {
  Button,
  Text,
  Flex,
  Textarea,
  useToast,
  FormControl,
  FormLabel,
  FormHelperText,
} from '@chakra-ui/react';
import { useBilling } from '../../../store/client/BillingContext';
import CustomToast from '../../../common/CustomToast';
import ConfirmModal from '../../../common/ConfirmModal';

const DeclineCustomPlanModal = ({
  isOpen,
  onClose,
  customPlanRequestId,
  onSuccess,
}) => {
  const { declineCustomPlan } = useBilling();
  const [loading, setLoading] = useState(false);
  const [reason, setReason] = useState('');
  const toast = useToast();

  const handleDecline = async () => {
    setLoading(true);

    try {
      await declineCustomPlan(customPlanRequestId, reason || null);

      toast({
        render: (props) => (
          <CustomToast
            status="info"
            title="Offer declined"
            description="You can request a new custom plan anytime."
            onClose={props.onClose}
            id={props.id}
          />
        ),
      });

      onSuccess();
    } catch (error) {
      const errorMessage = error.response?.data?.errors?.[0];

      toast({
        render: (props) => (
          <CustomToast
            status="error"
            title="Error"
            description={errorMessage || 'Something went wrong'}
            onClose={props.onClose}
            id={props.id}
          />
        ),
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (isOpen) {
      setReason('');
    }
  }, [isOpen]);

  return (
    <ConfirmModal
      isOpen={isOpen}
      onClose={onClose}
      title="Decline this custom plan offer?"
      description="Are you sure you want to decline this custom plan offer? Your current plan will remain active."
      primaryButton={{
        label: 'Go back to offer',
        onClick: onClose,
      }}
      secondaryButton={{
        label: 'Decline offer',
        onClick: handleDecline,
        isLoading: loading,
        loadingText: 'Processing',
      }}
    >
      <Flex direction="column" w="100%">
        <FormControl>
          <FormLabel variant="templateBuilderLabel">
            What didn’t work for you? (optional)
          </FormLabel>
          <Textarea
            bg="softWhite"
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            rows={4}
            resize="none"
          />
          <FormHelperText mt={2}>
            Your feedback helps us tailor future offers more closely to your
            needs.
          </FormHelperText>
        </FormControl>
      </Flex>
    </ConfirmModal>
  );
};

export default DeclineCustomPlanModal;
